module.exports = __webpack_public_path__ + "static/appicon-512x512-8a9a9e386b2d8727f4bb2788bc13aad2.png";